import React from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import OutlinedInput from '@mui/material/OutlinedInput';
import CancelIcon from '@mui/icons-material/Cancel';

import styles from './SearchFilter.module.scss'


const SearchFilter = observer(({model}) => {

  const search = useLocalObservable(() => ({
    text: model.search,
    apply: false,
    get isEmpty() {
      return this.text.length == 0
    },
    cancel() {
      this.text = ''
      this.doAction()
    },
    change(e) {
      this.text = e.target.value
      this.apply = false
    },
    onKeyUp(e) {
      if(e.keyCode === 13) {
        this.doAction()
      }
    },
    doAction() {
      this.apply = true
      model.setSearch(this.text)
    }
  }))

  const cancel = search.isEmpty ? null : <CancelIcon className={styles.cancel} onClick={search.cancel} />
  const appendClz = search.isEmpty ? styles.empty : (search.apply ? styles.apply : styles.changing)
  return <div className={styles.root}>
    <OutlinedInput 
      className={appendClz}
      classes={{
        root: styles.search, 
        notchedOutline: styles.notchedOutline, 
        input: styles.input, 
        focused: styles.focused
      }}
      value={search.text}
      onBlur={search.doAction}
      onKeyUp={search.onKeyUp}
      onChange={search.change}
      placeholder="Search for loops..."
      size="small" 
      endAdornment={cancel}/>
  </div>
})


export default SearchFilter